(function() {
    'use strict';

    /**
     * blocks.router Module
     *
     * Description configure application router
     */
    angular.module('blocks.router', [
        'ui.router',
        'blocks.logger'
    ]);
})();
